import { Injectable } from "@angular/core";
import { BaseFacade } from "@webapp/core/abstracts/services/base-facade.service";
import { PermissionsApiService } from "./permissions-api.service";
import { Permission, PermissionDTO } from "@webapp/permissions/models/permissions.model";
import { PermissionsState } from "@webapp/permissions/services/permissions-state.service";
import { Observable, map } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class PermissionsFacade extends BaseFacade<Permission, PermissionDTO, PermissionsState, PermissionsApiService> {
  constructor(state: PermissionsState, api: PermissionsApiService) {
    super(state, api);
  }

  public hasPermission$(action: Permission): Observable<boolean> {
    return this.apiService.getEffectivePermissions$().pipe(map((permissions) => permissions.indexOf(action) > -1));
  }

  public getPermissions$(): Observable<Permission[]> {
    return this.apiService.getEffectivePermissions$();
  }
}
